<template>
<div class="wrapper" >
  <video-player class="video-player-box vjs-big-play-centered"
    ref="videoPlayer"
    :options="playerOptions"
    :playsinline="true"
    customEventName="customstatechangedeventname">
  </video-player>
</div>
</template>

<script>
export default {
  props: ['postsrc', 'autoplay'],
  data () {
    return {
      playerOptions: {
        muted: false,
        autoplay: this.autoplay,
        language: 'en',
        fluid: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: '/videos/Assistenzhunde/Führen_SD_WEB.mp4'
        }],
        poster: '/img/novideo.png'
      }
    }
  },
  mounted () {
    this.playerSetSrc(this.postsrc)
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    playerSetSrc (url) {
      this.player.src(url)
    }
  }
}
</script>

<style scoped>

.video-player-box{
  width: 400px;
  height: 150px;
  position: absolute;
  margin-top:-350px;
  margin-left:620px;
  z-index:10;
}

@media (orientation: landscape) and (max-width: 980px) {

    .video-player-box{
    width: 240px;
    height: 75px;
    position: absolute;
    margin-top:-270px;
    margin-left:220px;
  }
}

@media (orientation: landscape) and (max-width: 823px) {

    .video-player-box{
    width: 340px;
    margin-top:-285px;
    margin-left:216px;
  }
}

@media (orientation: landscape) and (max-width: 812px) {

    .video-player-box{
    width: 361px;
    margin-top:-285px;
    margin-left:196px;
  }
}

@media (orientation: landscape) and (max-width: 740px) {

    .video-player-box{
    width: 300px;
    margin-top:-285px;
    margin-left:189px;
  }
}

@media (orientation: landscape) and (max-width: 736px) {

    .video-player-box{
    width: 250px;
    margin-top:-285px;
    margin-left:218px;
  }
}

@media (orientation: landscape) and (max-width: 731px) {

    .video-player-box{
    width: 245px;
    margin-top:-285px;
    margin-left:218px;
  }
}

@media (orientation: landscape) and (max-width: 667px) {

    .video-player-box{
    width: 215px;
    margin-top:-250px;
    margin-left:197px;
  }
}

@media (orientation: landscape) and (max-width: 640px) {

    .video-player-box{
    width: 200px;
    margin-top:-250px;
    margin-left:190px;
  }
}

@media (orientation: landscape) and (max-width: 568px) {

    .video-player-box{
    width: 200px;
    margin-top:-150px;
    margin-left:130px;
  }
}

@media (orientation:portrait){
    .video-player-box{
    position: absolute;
    z-index:5;
  }
}
@media (orientation: portrait) and (min-width: 737px) and (max-width: 980px) {

    .video-player-box{
    width: 400px;
    height: 150px;
    margin-top:-480px;
    margin-left:180px;
  }

}
@media (orientation: portrait) and (max-width: 736px) {
  .video-player-box{
    width: 300px;
    height: 150px;
    margin-top:-400px;
    margin-left:30px;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-height: 568px) and (orientation : portrait){

  .video-player-box{
    width: 320px;
    margin-top:-390px;
    margin-left:0px;
  }

}

@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation : portrait){

  .video-player-box{
    width: 365px;
    margin-top:-415px;
    margin-left:0px;
  }

}

@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation : portrait){
  .video-player-box{
    width: 375px;
    margin-top:-425px;
    margin-left:0px;
  }
}

@media only screen and (min-device-width: 411px) and (max-device-height: 823px) and (orientation : portrait){

  .video-player-box{
    width: 415px;
    margin-top:-461px;
    margin-left:0px;
  }

}

@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation : portrait){

  .video-player-box{
    width: 415px;
    margin-top:-461px;
    margin-left:0px;
  }

}

@media only screen and (min-device-width: 768px) and (max-device-height: 1024px) and (orientation : portrait){

  .video-player-box{
    width: 450px;
    margin-top:-483px;
    margin-left:159px;
  }

}

@media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (orientation : portrait){

  .video-player-box{
    width: 600px;
    margin-top:-450px;
    margin-left:0px;
  }

}

@media only screen and (min-device-width: 1024px) and (max-device-height: 768px) and (orientation : landscape){
  .video-player-box{
    width: 340px;
    margin-top:-300px;
    margin-left:159px;
  }
}

@media only screen and (min-device-width: 1366px) and (max-device-height: 1024px) and (orientation : landscape){
  .video-player-box{
    width: 440px;
    margin-top:-360px;
    margin-left:235px;
  }
}
</style>
